export enum AuthorType {
  User = "User",
  Company = "Company",
  Anonymous = "Anonymous"
}
